module.exports = __webpack_public_path__ + "img/fly-icon-map.65a8e640.svg";